import { LEASE_QUERY_PLAN_ID } from '../../plans/helpers';
import { useCheckoutCardFeatureFlag } from './useCheckoutCardFeatureFlag';

/**
 * Custom hook to determine if the LeaseQuery plan should be shown (depends on plan ID and feature flag)
 * @param planId - The ID of the plan to check
 * @returns Boolean indicating if the LeaseQuery plan should be shown
 */
export const useShowLeaseQueryPlan = (planId: number): boolean => {
  const isLQACheckoutCardEnabled = useCheckoutCardFeatureFlag();

  return planId === LEASE_QUERY_PLAN_ID && isLQACheckoutCardEnabled;
};
